import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, Home as HomeIcon, Calendar, Sparkles, CheckCircle2, Clock, Shield, Camera } from 'lucide-react';

const Services = () => {
  const allServices = [
    {
      id: 1,
      icon: Zap,
      title: "Airbnb Express",
      subtitle: "Le service le plus populaire",
      description: "Nettoyage complet entre deux locataires. Parfait pour les turnovers rapides.",
      features: [
        "Nettoyage complet en 1h",
        "Changement de draps et linge",
        "Nettoyage cuisine et salle de bain",
        "Aspirateur et lavage des sols",
        "Vérification des équipements",
        "Photos avant/après sur WhatsApp"
      ],
      price: "À partir de 150 DH",
      duration: " 1 heure ",
      ideal: "Appartements 1-2 chambres"
    },
    {
      id: 2,
      icon: Calendar,
      title: "Abonnement Mensuel",
      subtitle: "Économisez jusqu'à 30%",
      description: "Pour les hôtes qui ont des turnovers réguliers. Service prioritaire et tarifs préférentiels.",
      features: [
        "5 nettoyages par mois minimum",
        "Priorité de réservation",
        "Tarif réduit",
        "Rapport mensuel détaillé",
        "Agent dédié",
        "Intervention urgente gratuite"
      ],
      price: "1000 DH/mois (8 nettoyages)",
      duration: "Engagement mensuel",
    
    },
    {
      id: 3,
      icon: Clock,
      title: "Service Urgence",
      subtitle: "Intervention < 4h",
      description: "Besoin d'un nettoyage last-minute? On arrive en moins de 4 heures.",
      features: [
        "Réponse immédiate",
        "Arrivée en moins de 4h",
        "Disponible 7j/7",
        "Nettoyage express complet",
        "Garantie de qualité",
        "Photos en temps réel"
      ],
      price: "170 DH",
      duration: " 1 heures",
      ideal: "Réservations last-minute"
    },
    {
      id: 4,
      icon: Sparkles,
      title: "Nettoyage Profond",
      subtitle: "Remise à neuf complète",
      description: "Nettoyage en profondeur pour préparer la saison ou après travaux.",
      features: [
        "Nettoyage intensif de toutes surfaces",
        "Vitres intérieures et extérieures",
        "Dégraissage cuisine",
        "Détartrage salle de bain",
        "Nettoyage des placards",
        "Traitement anti-bactérien"
      ],
      price: "À partir de 600 DH" ,
      ideal: "Préparation de saison, après travaux"
    }
  ];

  const whyChooseUs = [
    {
      icon: Shield,
      title: "Garantie Qualité",
      description: "Si vous n'êtes pas satisfait dans les 24h, on re-nettoie gratuitement ou remboursement 100%"
    },
    {
      icon: Camera,
      title: "Photos Systématiques",
      description: "Vous recevez des photos avant/pendant/après chaque intervention sur WhatsApp"
    },
    {
      icon: CheckCircle2,
      title: "Checklist 27 Points",
      description: "Notre protocole standardisé garantit qu'aucun détail n'est oublié"
    },
    {
      icon: Clock,
      title: "Ponctualité Garantie",
      description: "On arrive à l'heure convenue. Toujours. Votre temps est précieux."
    }
  ];

  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="page-hero-content">
          <h1>Nos Services de Nettoyage Airbnb</h1>
          <p>Solutions professionnelles adaptées à vos besoins. De l'express à l'abonnement mensuel.</p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="services-detail-section">
        <div className="section-container">
          {allServices.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <div key={service.id} className={`service-detail-card ${index % 2 === 1 ? 'reverse' : ''}`}>
                <div className="service-detail-icon">
                  <IconComponent size={48} />
                </div>
                <div className="service-detail-content">
                  <div className="service-detail-header">
                    <div>
                      <h2>{service.title}</h2>
                      <p className="service-subtitle">{service.subtitle}</p>
                    </div>
                    <div className="service-price-tag">{service.price}</div>
                  </div>
                  <p className="service-description">{service.description}</p>
                  
                  <div className="service-meta">
                    <div className="meta-item">
                      <Clock size={16} />
                      <span>{service.duration}</span>
                    </div>
                    <div className="meta-item">
                      <HomeIcon size={16} />
                      <span>{service.ideal}</span>
                    </div>
                  </div>

                  <div className="service-features">
                    <h4>Ce qui est inclus :</h4>
                    <ul>
                      {service.features.map((feature, idx) => (
                        <li key={idx}>
                          <CheckCircle2 size={18} />
                          <span>{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>

                  <Link to="/contact" className="gradient-btn">Réserver ce service</Link>
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose-section">
        <div className="section-container">
          <h2>Pourquoi Choisir NeoNkawa?</h2>
          <div className="why-choose-grid">
            {whyChooseUs.map((item, index) => {
              const IconComponent = item.icon;
              return (
                <div key={index} className="why-choose-card">
                  <div className="why-icon">
                    <IconComponent size={32} />
                  </div>
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="service-cta">
        <h2>Besoin d'un Service Personnalisé?</h2>
        <p>Contactez-nous pour discuter de vos besoins spécifiques</p>
        <div className="cta-buttons">
          <Link to="/contact" className="white-btn">Demander un Devis</Link>
          <a href="https://wa.me/212653555855" target="_blank" rel="noopener noreferrer" className="outline-white-btn">
            WhatsApp: +212 653555855
          </a>
        </div>
      </section>
    </div>
  );
};

export default Services;
